import React, { useState } from 'react';
import styles from './FeatureVideosPage.module.css';
import VideoCard from '../../components/commons/VideoCard';
import { useTranslation } from 'react-i18next';

const FeatureVideosPage = () => {
  const { t } = useTranslation();

  const allVideos = [
    {
      'fileName': 'Profile-and-Resume-2.m4v',
      'text': 'common.profileResume',
    },
    {
      'fileName': 'classes-and-groups.m4v',
      'text': 'common.classesAndGroups',
    },
    {
      'fileName': 'Course-new.m4v',
      'text': 'common.courses',
    },
    {
      'fileName': 'Quiz-new.m4v',
      'text': 'quiz.quizzes',
    },
    {
      'fileName': 'Assignments.m4v',
      'text': 'assignment.assignments',
    },
    {
      'fileName': 'Live-class.m4v',
      'text': 'common.liveClasses',
    },   
    
  ]



  return (
    <div className={styles.main_container}>
      <span className={styles.heading}>{t('common.chalkmatesFeatures')}</span>
      <div className={styles.videos_container}>
        {allVideos.map((item, index) => <>
          <div className={styles.video_card}>
            <VideoCard key={index} path={`/Image/FeatureVideos/${item.fileName}`} />
            <span>{t(`${item.text}`)}</span>
          </div>

        </>
        )}

      </div>
    </div>
  )
}

export default FeatureVideosPage;